export default __webpack_public_path__ + "static/media/kakaoFrame125.dcc203db.png";